import request from '@/utils/request'

export function addShared(data) {
  return request.post('/consultation-shared/add', data)
}

export function getSharedList(data) {
  return request.post('/consultation-shared/list', data)
}

export function modifyShared(data) {
  return request.post('/consultation-shared/modify', data)
}

export function addSharedDetail(data) {
  return request.post('/consultation-shared/add-detail', data)
}

export function modifySharedDetail(data) {
  return request.post('/consultation-shared/modify-detail', data)
}

export function deleteSharedDetail(data) {
  return request.post('/consultation-shared/delete-detail', data)
}



// WEBPACK FOOTER //
// ./src/api/consultShared.js